/** `PromiseSettledResult.status` values from `Promise.allSettled`. */
export const PROMISE_SETTLED_STATUS = {
  FULFILLED: "fulfilled",
  REJECTED: "rejected"
} as const;
